export const SHELF_VIEW_OPTIONS = [
  { text: 'Shelf Heatmap', value: 'heatmap', listText: 'Shelf Heatmap' },
  { text: 'Product Heatmap', value: 'pheatmap', listText: 'Product Heatmap' },
  { text: 'Clicks', value: 'clicks', listText: 'Clicks' },
  { text: 'Shelf view', value: 'shelfs', listText: 'Shelf view' }
]

export const SUBSCRIBE_VIEW_OPTION_KEYS = [
  'subscribeRate',
  'subscribeSpend',
  'considerationRate',
  'churnRate',
  'reversalRate',
  'frequency'
]

export const BANNER_VIEW_OPTION_KEYS = [
  'bannerImpressions',
  'bannerClicks',
  'bannerCtr',
  'bannerFunnelPopup',
  'bannerFunnelCart',
  'bannerAvgViewToClick'
]

export const CHART_VIEW_OPTIONS = [
  { text: 'Purchase selection', value: 'amount', listText: 'Purchase selection' },
  { text: 'Purchase quantity', value: 'pVolume', listText: 'Purchase quantity' },
  { text: 'Purchase amount', value: 'pAmount', listText: 'Purchase amount' },
  { text: 'Purchased, picked up only', value: 'totalPickedUp', listText: 'Purchased, picked up only' },
  { text: 'Attention span', value: 'attention', listText: 'Attention span' },
  { text: 'Time to cart', value: 'time', listText: 'Time to cart' },
  { text: 'Time to first click', value: 'timeToFirstClick', listText: 'Time to first click' },
  { text: 'Subscribe rate', value: 'subscribeRate', listText: 'Subscribe rate' },
  { text: 'Subscribe spend', value: 'subscribeSpend', listText: 'Subscribe spend' },
  { text: 'Consideration rate', value: 'considerationRate', listText: 'Consideration rate' },
  { text: 'Churn rate', value: 'churnRate', listText: 'Churn rate' },
  { text: 'Reversal rate', value: 'reversalRate', listText: 'Reversal rate' },
  { text: 'Delivery frequency', value: 'frequency', listText: 'Delivery frequency' },
  { text: 'Banner impressions', value: 'bannerImpressions', listText: 'Banner impressions' },
  { text: 'Banner clicks', value: 'bannerClicks', listText: 'Banner clicks' },
  { text: 'Banner CTR', value: 'bannerCtr', listText: 'Banner CTR' },
  { text: 'Banner click-to-popup', value: 'bannerFunnelPopup', listText: 'Banner click-to-popup' },
  { text: 'Banner click-to-cart', value: 'bannerFunnelCart', listText: 'Banner click-to-cart' },
  { text: 'Banner avg view-to-click', value: 'bannerAvgViewToClick', listText: 'Banner avg view-to-click' }
]

export const CHART_NO_PRICE_VIEW_OPTIONS = [
  { text: 'Purchase selection', value: 'amount', listText: 'Purchase selection' },
  { text: 'Purchase quantity', value: 'pVolume', listText: 'Purchase quantity' },
  { text: 'Purchased, picked up only', value: 'totalPickedUp', listText: 'Purchased, picked up only' },
  { text: 'Attention span', value: 'attention', listText: 'Attention span' },
  { text: 'Time to cart', value: 'time', listText: 'Time to cart' },
  { text: 'Time to first click', value: 'timeToFirstClick', listText: 'Time to first click' },
  { text: 'Banner impressions', value: 'bannerImpressions', listText: 'Banner impressions' },
  { text: 'Banner clicks', value: 'bannerClicks', listText: 'Banner clicks' },
  { text: 'Banner CTR', value: 'bannerCtr', listText: 'Banner CTR' },
  { text: 'Banner click-to-popup', value: 'bannerFunnelPopup', listText: 'Banner click-to-popup' },
  { text: 'Banner click-to-cart', value: 'bannerFunnelCart', listText: 'Banner click-to-cart' },
  { text: 'Banner avg view-to-click', value: 'bannerAvgViewToClick', listText: 'Banner avg view-to-click' }
]

export const HELP_OPTIONS = {
  shelf: {
    heatmap:
      '<b>Shelf Heatmap</b> A graphic visualization of the density of clicks on the shelf. This view is a rendering of the programmed shelf and does not account for any randomization or logic.',
    pheatmap: '<b>Product Heatmap</b> A graphic visualization of the density of clicks on a specific product.',
    clicks:
      '<b>Clicks</b> represent the precise coordinates of every click on the shelf. This view is a rendering of the programmed shelf and does not account for any randomization or logic.',
    shelfs: '<b>Shelf view</b> This view represents a rendering of a shelf as it was originally programmed.'
  },
  'product-metrics': {
    amount: '<b>Purchase Selection</b> represents the proportion of individuals who bought the product.',
    pAmount: '<b>Purchase Amount</b> is the mean spend on a product among those who purchased that product.',
    pVolume:
      '<b>Purchase Quantity</b> is the mean number of products placed in the cart among those who purchased that product.',
    totalPickedUp:
      '<b>Purchased, picked up only</b> represents the percentages of individuals who bought the product, those who solely picked it up, and those who did neither.',
    attention:
      "<b>Attention Span</b> is a geometric mean time spent viewing a product's detail view among those who viewed that product.",
    time: '<b>Time to Cart</b> represents the geometric mean time between starting the task and putting the product in the cart among those who put the product into the cart.',
    timeToFirstClick:
      '<b>Time to first click</b> represents the geometric mean time between starting the task and clicking on the product the first time among those who clicked on the product.',
    subscribeRate:
      '<b>Subscribe Rate</b> is the percentage of purchases made through subscription vs one-time purchase among those who purchased the product.',
    subscribeSpend: '<b>Subscribe Spend</b> is the mean subscription spend on a product among those who subscribed.',
    considerationRate:
      '<b>Consideration Rate</b> is the percentage of respondents who toggled to subscribe mode but did not follow through with a subscription.',
    churnRate: '<b>Churn Rate</b> is the percentage of subscriptions that were subsequently removed from the cart.',
    reversalRate:
      '<b>Reversal Rate</b> is the percentage of purchases where the last subscribe toggle contradicts the purchase outcome.',
    frequency:
      '<b>Delivery Frequency</b> shows the most chosen subscription delivery interval per product and the percentage of subscribers who chose it.',
    bannerImpressions:
      "<b>Banner Impressions</b> is the total number of times a product's banner ad was shown to respondents.",
    bannerClicks: "<b>Banner Clicks</b> is the total number of times respondents clicked on a product's banner ad.",
    bannerCtr:
      '<b>Banner CTR</b> (Click-Through Rate) is the percentage of banner impressions that resulted in a click.',
    bannerFunnelPopup:
      '<b>Banner Click-to-Popup</b> is the percentage of banner clicks that led to opening the product popup.',
    bannerFunnelCart:
      '<b>Banner Click-to-Cart</b> is the percentage of banner clicks that led to adding the product to the cart.',
    bannerAvgViewToClick:
      '<b>Banner Avg View-to-Click</b> is the geometric mean time (in seconds) between a banner impression and the first click on it.'
  }
}

export const DEFAULT_SELECT_VALUES = {
  shelf: 'heatmap',
  'product-metrics': 'amount'
}

export const DROPDOWN_TEXT = {
  shelf: 'Shelf Metrics',
  'product-metrics': 'Product Metrics'
}
